export default "__VITE_ASSET__8ebb512c__"